/**
 * Sidebar menu for easyAccessOperator (userType = 6).
 * Access System: ticket management + voucher management. No other menu items.
 */
export function getMenuList(context) {
  const { easyAccessOperatorMenu } = context;
  return [easyAccessOperatorMenu].filter(Boolean);
}
